import { getSuperType, NODE_SUPERTYPE, NODE_TYPE } from "../common/linqset-model"
import { ACTION_TYPE, CARBON_SCOPE } from "../common/organisation"

export const IMAGE_EXCLAMATION = 'assets/images/exclamation.svg'
export const IMAGE_LINQ = 'assets/images/linq.svg'
export const GROUP_NODE_ICON = "assets/images/nodes/group-folder.png"
export const TAG_NODE_ICON = "assets/images/price-tag.svg"

export const getCarbonScopeColour = (scope:CARBON_SCOPE) => {
    switch(scope) {
        case CARBON_SCOPE.ScopeOne:
            return MODEL_COLOURS.CARBON_SCOPE1_COLOUR
        case CARBON_SCOPE.ScopeTwo:
            return MODEL_COLOURS.CARBON_SCOPE2_COLOUR
        case CARBON_SCOPE.ScopeThree:
            return MODEL_COLOURS.CARBON_SCOPE3_COLOUR
    }
}

export const getActionTypeColour = (type:ACTION_TYPE) => {
    switch (type) {
        case ACTION_TYPE.AUTOMATED:
            return MODEL_COLOURS.SYSTEM_COLOR
        case ACTION_TYPE.MANUAL:
            return MODEL_COLOURS.ROLE_COLOR
        case ACTION_TYPE.NONE:
            return MODEL_COLOURS.ACTION_COLOR
        case ACTION_TYPE.EXTERNAL:
            return MODEL_COLOURS.ROLE_HOVER_COLOR
        case ACTION_TYPE.BOTH:
            return MODEL_COLOURS.DARK_RED                        
    }
}
/*
	INFO_COLOR = '#009E73',
	ACTION_COLOR = '#E69F00',
	SYSTEM_COLOR = '#0072B2',
	ROLE_COLOR = '#CC79A7',
*/

export enum MODEL_COLOURS {
    SELECTION_COLOR = '#9aad77',
	INFO_COLOR = '#9aad77',
	ACTION_COLOR = '#faa74a',
	SYSTEM_COLOR = '#577a99',
	ROLE_COLOR = '#a36fa7',
    PEOPLE_COLOR = '#66023C',
    MODEL_COLOR = '#645e6b',
    // model nodes, and the links between them, in LINQ's own aubergine (the theme's primary, 800)
    MODEL_NODE_COLOR = '#312a37',
    INFRASTRUCTURE_COLOR = '#07589e',
    NOTES_COLOR = '#f9ebb2',
    OUTCOMES_COLOR = '#0a4b33ff',

	// Core hover colors
	INFO_HOVER_COLOR = '#667b44',
	ACTION_HOVER_COLOR = '#ce5e25',
	SYSTEM_HOVER_COLOR = '#385b69',
	ROLE_HOVER_COLOR = '#623264',
	PEOPLE_HOVER_COLOR = '#084760',
    MODEL_HOVER_COLOR = '#6a00ef',
    MODEL_NODE_HOVER_COLOR = '#6a00ef',
    INFRASTRUCTURE_HOVER_COLOR = '#033e55',
    NOTES_HOVER_COLOR = '#6d6440',
    OUTCOMES_HOVER_COLOR = '#053f2aff',

    CARBON_SCOPE1_COLOUR = '#000000',
    CARBON_SCOPE2_COLOUR = '#A1A1A1',
    CARBON_SCOPE3_COLOUR = '#5E5E5E',
    CARBON_SCOPE1_HOVER_COLOUR = '#000000',
    CARBON_SCOPE2_HOVER_COLOUR = '#2B2B2B',
    CARBON_SCOPE3_HOVER_COLOUR = '#2B2B2B',

    FILTERED_MODEL = '#cdcdcd',
    PROJECT_MODEL = '#FF0000',

    NODE_SELECT_COLOR = "#62C6C0",
    
	// Detail colors
	INFO_OUTPUT_COLOR = '#d4dcc6',
	EXCLUDED_COLOR = '#cdcdcd',
    EXCLUDED_HOVER_COLOR = '#2B2B2B',
	FILTERED_COLOR = '#cdcdcd',
	SELECTED_COLOR = '#68b0ff',
	EXCLUDED_TEXT_COLOR = '#999999',
	FILTERED_TEXT_COLOR = '#ffffff',

	// Linqset colors
	LINQSET_COLLAPSE_COLOR = '#faa74a',
	LINQSET_COLLAPSE_BORDER = '#646464',
	LINQSET_EXPANDED_COLOR = '#f0f0f0',
	LINQSET_EXPANDED_BORDER = '#646464',

	LINQSET_COLLAPSE_EXCLUDED_COLOR = '#cdcdcd',
	LINQSET_COLLAPSE_EXCLUDED_BORDER = '#aaaaaa',
	LINQSET_EXPANDED_EXCLUDED_COLOR = '#ffffff',
	LINQSET_EXPANDED_EXCLUDED_BORDER = '#cdcdcd',

    GREEN = '#008000',
    DARK_GREEN = '#006400',
    ORANGE = '#FFA500',
    DARK_ORANGE = '#FF8C00',
    RED = '#FF0000',
    DARK_RED = '#8B0000',

    BILLING_NODES = '#03045E',
    BILLING_PROJECTS = '#0077B6',
    BILLING_USERS = '#00B4D8',
    BILLING_HOVER = '#1B263B',
}

export enum INSIGHTS_COLOURS {
    COST = '#D62728',
    TIME = '#1F77B4',
    CARBON = '#6C6C6C',
    VALUE = '#9467BD',
    REVENUE = '#FFBF00',
    ITEMS = '#17BECF'
}

export const getColourForType = (type:NODE_TYPE) => {
    if (type === NODE_TYPE.MODEL) return MODEL_COLOURS.MODEL_NODE_COLOR
    if (type === NODE_TYPE.ASSET) return MODEL_COLOURS.INFO_COLOR
    return getColourForSuperType(getSuperType(type))
}

export const getColourForSuperType = (type:NODE_SUPERTYPE) => {
    switch(type) {
        case NODE_SUPERTYPE.INFORMATION:
            return MODEL_COLOURS.INFO_COLOR
        case NODE_SUPERTYPE.ACTION:
            return MODEL_COLOURS.ACTION_COLOR
        case NODE_SUPERTYPE.SYSTEM:
            return MODEL_COLOURS.SYSTEM_COLOR
        case NODE_SUPERTYPE.ROLE:
            return MODEL_COLOURS.ROLE_COLOR
        case NODE_SUPERTYPE.PEOPLE:
            return MODEL_COLOURS.PEOPLE_COLOR
        case NODE_SUPERTYPE.INFRASTRUCTURE:
            return MODEL_COLOURS.INFRASTRUCTURE_COLOR
        case NODE_SUPERTYPE.NOTES:
            return MODEL_COLOURS.NOTES_COLOR
        case NODE_SUPERTYPE.OUTCOMES:
            return MODEL_COLOURS.OUTCOMES_COLOR
    }
}

export enum LABEL_TYPES {
    NODE_NAME,
    VALUE,
    TAG,
    COSTS,
    QUEUE,
    GROUP_NAME
}

/**
 * Converts a hexidecimal color into an array containing A, R, G, B values
 * This is used with yfiles when creating pens and brushes
 * @param hex
 * @returns {[number,number,number,number]|[number,number,number,number]}
 */
export const colorAsARGB = (hex:string) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        a: 255,
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
        } : 
        {a:255, r:0, g:0, b:0};
}
